// extracted by mini-css-extract-plugin
export default {"videoWp":"index_videoWp_U4noT","poster":"index_poster_LtalN","icon":"index_icon_61ebR"};